import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RouterComponent from "./components/Layout/RouterComponent/RouterComponent";
import reportWebVitals from "./reportWebVitals";
import ReactGA from "react-ga4";

ReactGA.initialize("G-3S7HSEDDF7");

ReactGA.send({ hitType: "pageview", page: window.location.pathname,  })
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterComponent />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
